// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import requestUtil from '@/common/js/requestUtil'
import 'lib-flexible'
import VueClipboard from 'vue-clipboard2'

Vue.config.productionTip = false
Vue.use(requestUtil)   //封装的axios请求接口
Vue.use(VueClipboard)

/**
 * 引入百度统计js
 */
import baidu from '@/common/js/baidu'
Vue.use(baidu)  

import { Toast, Scroller } from '@nutui/nutui';
Toast.install(Vue);
Scroller.install(Vue);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data() {
    return {
      indexPageIndex: null,
      indexPageThemeIndex:null,
      indexItemList: null,
      indexThemeList:null,
      indexScrollTop: 0,

      listId: null,
      listPageIndex: null,
      listItemList: null,
      listScrollTop: 0,

      searchKey:"",
      searchPageIndex:null,
      searchItemList: null,
      searchScrollTop: 0,
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js